export enum OrderStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
}
